import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'

import store from 'store';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
    locale: store.get('locale') || 'zh-cn',
    token: '',
    publicSideMenu: [],
  },
  mutations: {
    //
    SETLOCALE(state, locale) {
      store.set('locale', locale);
      state.locale = locale;
    },
    SETPUBLICSIDEMENU(state, publicSideMenu) {
      state.publicSideMenu = publicSideMenu;
    },
    SETTOKEN(state, token) {
      state.token = token;
    }
  },
  getters: {
    getLocale: state => state.locale,
    getPublicSideMenu: state => state.publicSideMenu,
  },
  actions: {
    //
  },
  modules: {
    user,
    app
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js